module.exports = __webpack_public_path__ + "static/img/user-management.06429d8c.svg";